import PropTypes from 'prop-types';

import { useEffect, useState } from 'react';
import Container, { ContainerProps as MuiContainerProps } from '@mui/material/Container';
import { Navigation } from '../../components/Dashboard';
import { SideNav } from '../../components/Dashboard/SideNav';
import { Box, CircularProgress } from '@mui/material';
import { windowExists, parseToken, useLocalStorage } from '@classity-edtech/ui-base';
import { useNavigate } from 'react-router-dom';
import { webPaths } from '../../routes/paths';
import { useGetPageContentQuery } from '../../services/seoContent';

export interface DashboardLayoutProps extends MuiContainerProps {}

const DashboardLayout = ({ className, children }: DashboardLayoutProps) => {
  const navigate = useNavigate();
  const [, setUserFlow] = useLocalStorage('userFlow', '');
  const token =
    windowExists &&
    parseToken(
      (windowExists?.localStorage as { getItem: (key: string) => void })?.getItem('token'),
    );
  const { data, isLoading: fetchingContent } = useGetPageContentQuery({
    tag: 'referFriend',
    contentType: 'page',
  });

  const extractData = () => {
    const title = data?.sections?.[0]?.fields?.list?.[0]?.fields?.title;
    const text =
      data?.sections?.[0]?.fields?.list?.[0]?.fields?.description?.content?.[0]?.content?.[0]
        ?.value;
    const url = data?.sections?.[0]?.fields?.list?.[0]?.fields?.reference?.fields?.url;

    return {
      text: text,
      url: url,
      title: title,
    };
  };

  const [showSideNav, setShowSideNav] = useState(false);

  const toggleSideNav = () => {
    setShowSideNav(showSideNav => !showSideNav);
  };

  useEffect(() => {
    if (!token.exp || token.exp * 1000 < new Date().getTime()) {
      setUserFlow('assessment');
      navigate(`/${webPaths.onboardStudent}`);
      localStorage.removeItem('token');
    }
  }, []);

  return (
    <Container className={className}>
      {fetchingContent ? (
        <Box
          className={`${className} loader`}
          sx={{
            display: 'flex',
            width: '100vw',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Navigation toggleSideNav={toggleSideNav} />
          <Box sx={{ display: 'flex', gap: 6, mt: 4 }}>
            <SideNav
              showSideNav={showSideNav}
              toggleSideNav={toggleSideNav}
              shareData={extractData()}
            />
            {children}
          </Box>
        </>
      )}
    </Container>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

DashboardLayout.defaultProps = {
  children: null,
  className: null,
};

export default DashboardLayout;
